//假设这里定义用户功能模块的api请求

//一般根据具体的接口服务模块约定
const baseURL = '/api';
import listRequest from '../../js/listRequest.js';

export const AIMonitorApi = {
    getList(opt: any, pageData?: any) {
        var servicesPath = baseURL + '/v1/school/list';
        let context = opt.context;
        let pager = opt.pager;
        let initCodeRules = opt.initCodeRules;

        listRequest.request({
            // isDebug:true,//本地临时数据专用
            // tempData:listData,//本地临时数据专用ds

            url: servicesPath,
            context: context,
            pager: pager,
            waitingtip: '加载中，请稍等...',
            data: {},
            appendAttributes: opt.appendAttributes || {},
            urlQueryParmas: opt.urlQueryParmas || {},

            appendUniAppToken: false, //
            prepareRender(data: any) {
                //如果列表需要显示编码的中文，则需要重写prepareRender
                context.$pageHelper.initListRowsCode(data.data.list, initCodeRules);
                // console.log('--------------', data.data.list);
                // opt.success(data.data,opt);
                return data;
            },
            afterRender: opt.afterRender
        });
    },
    getAdministrativeDistrict(opt: any) {
        var servicesPath = baseURL + '/v1/user/regionalism';

        let context = opt.context;
        let pageData = opt.data || {};
        let urlQueryParmas = opt.urlQueryParmas;
        listRequest.request({
            url: servicesPath,
            context: context,
            urlQueryParmas: urlQueryParmas,
            isShowLoading: false,
            ajaxOpt: {
                //ajax的参数配置
                type: 'GET' //HTTP请求类型
            },
            success(data: any, parameters: any) {
                if (opt.success != undefined && typeof opt.success == 'function') {
                    opt.success(data, parameters);
                }
            },
            error(error: any, message: string, parameters: any) {
                if (opt.error != undefined && typeof opt.error == 'function') opt.error(error, message, parameters);
            }
        });
    },
    getSchoolListByCity(opt: any) {
        var servicesPath = baseURL + '/v1/school/district/schools';
        let context = opt.context;
        let urlQueryParmas = opt.urlQueryParmas || {};
        listRequest.request({
            url: servicesPath,
            context: context,
            isShowLoading: false,
            urlQueryParmas: urlQueryParmas,
            success(data: any, parameters: any) {
                if (opt.success != undefined && typeof opt.success == 'function') {
                    opt.success(data, parameters);
                }
            },
            error(error: any, message: string, parameters: any) {
                if (opt.error != undefined && typeof opt.error == 'function') {
                    opt.error(error, message, parameters);
                }
            }
        });
    },
    getOverviewData(opt: any) {
        var servicesPath = baseURL + opt.url;
        let context = opt.context;
        let pageData = opt.data || {};

        let ajaxType = 'GET';
        context.$basicRequest.request({
            url: servicesPath,
            context: context,
            isShowLoading: false,
            ajaxOpt: {
                //ajax的参数配置
                type: ajaxType //HTTP请求类型
            },
            data: pageData,
            success(data: any, parameters: any) {
                if (opt.success != undefined && typeof opt.success == 'function') {
                    opt.success(data, parameters);
                }
            },
            error(error: any, message: string, parameters: any) {
                if (opt.error != undefined && typeof opt.error == 'function') {
                    opt.error(error, message, parameters);
                }
            }
        });
    },
    getUsageStatisticsData(opt: any) {
        var servicesPath = baseURL + opt.url;
        let context = opt.context;
        let pageData = opt.data || {};

        let ajaxType = 'GET';
        context.$basicRequest.request({
            url: servicesPath,
            context: context,
            isShowLoading: false,
            ajaxOpt: {
                //ajax的参数配置
                type: ajaxType //HTTP请求类型
            },
            data: pageData,
            success(data: any, parameters: any) {
                if (opt.success != undefined && typeof opt.success == 'function') {
                    opt.success(data, parameters);
                }
            },
            error(error: any, message: string, parameters: any) {
                if (opt.error != undefined && typeof opt.error == 'function') {
                    opt.error(error, message, parameters);
                }
            }
        });
    },
    getHistogramStatisticsData(opt: any) {
        var servicesPath = baseURL + opt.url;
        let context = opt.context;
        let pageData = opt.data || {};

        let ajaxType = 'GET';
        context.$basicRequest.request({
            url: servicesPath,
            context: context,
            isShowLoading: false,
            ajaxOpt: {
                //ajax的参数配置
                type: ajaxType //HTTP请求类型
            },
            data: pageData,
            success(data: any, parameters: any) {
                if (opt.success != undefined && typeof opt.success == 'function') {
                    opt.success(data, parameters);
                }
            },
            error(error: any, message: string, parameters: any) {
                if (opt.error != undefined && typeof opt.error == 'function') {
                    opt.error(error, message, parameters);
                }
            }
        });
    },
    getHistogramStaticsDataByHour(opt: any) {
        var servicesPath = baseURL + `/ecode/statistics/usage/histogram/school/${opt.schoolId}/byhour`;
        let context = opt.context;
        let pageData = opt.data || {};

        let ajaxType = 'GET';
        context.$basicRequest.request({
            url: servicesPath,
            context: context,
            isShowLoading: false,
            ajaxOpt: {
                //ajax的参数配置
                type: ajaxType //HTTP请求类型
            },
            data: pageData,
            success(data: any, parameters: any) {
                if (opt.success != undefined && typeof opt.success == 'function') {
                    opt.success(data, parameters);
                }
            },
            error(error: any, message: string, parameters: any) {
                if (opt.error != undefined && typeof opt.error == 'function') {
                    opt.error(error, message, parameters);
                }
            }
        });
    },
    getClassListBySchool(opt: any) {
        var servicesPath = baseURL + `/v1/class/classes`;
        let context = opt.context;
        let pageData = opt.data || {};

        let ajaxType = 'GET';
        context.$basicRequest.request({
            url: servicesPath,
            context: context,
            isShowLoading: false,
            ajaxOpt: {
                //ajax的参数配置
                type: ajaxType //HTTP请求类型
            },
            data: pageData,
            success(data: any, parameters: any) {
                if (opt.success != undefined && typeof opt.success == 'function') {
                    opt.success(data, parameters);
                }
            },
            error(error: any, message: string, parameters: any) {
                if (opt.error != undefined && typeof opt.error == 'function') {
                    opt.error(error, message, parameters);
                }
            }
        });
    },
    getRulesBySchool(opt: any) {
        var servicesPath = '/api/ecode/quota-rules';
        let context = opt.context;
        let pageData = opt.data || {};
        context.$basicRequest.request({
            url: servicesPath,
            context: context,
            waitingtip: '请稍等...',
            data: pageData,
            ajaxOpt: {
                //ajax的参数配置
                type: 'GET' //HTTP请求类型
            },
            success(data: any, parameters: any) {
                if (opt.success != undefined && typeof opt.success == 'function') {
                    opt.success(data, parameters);
                }
            },
            error(error: any, message: string, parameters: any) {
                if (opt.error != undefined && typeof opt.error == 'function') {
                    opt.error(error, message, parameters);
                }
            }
        });
    },
    getSystemWarn(opt: any) {
        var servicesPath = '/api/ecode/statistics/exhausted/aggregation/byschool/overview';
        let context = opt.context;
        let pageData = opt.data || {};
        context.$basicRequest.request({
            url: servicesPath,
            context: context,
            waitingtip: '请稍等...',
            data: pageData,
            ajaxOpt: {
                //ajax的参数配置
                type: 'GET' //HTTP请求类型
            },
            success(data: any, parameters: any) {
                if (opt.success != undefined && typeof opt.success == 'function') {
                    opt.success(data, parameters);
                }
            },
            error(error: any, message: string, parameters: any) {
                if (opt.error != undefined && typeof opt.error == 'function') {
                    opt.error(error, message, parameters);
                }
            }
        });
    },
    getSchoolConfig(opt: any) {
        var servicesPath = baseURL + '/ecode/quota-rules/aggregation/byschool';
        let context = opt.context;
        let pageData = opt.data || {};
        context.$basicRequest.request({
            url: servicesPath,
            context: context,
            waitingtip: '请稍等...',
            data: pageData,
            ajaxOpt: {
                //ajax的参数配置
                type: 'GET' //HTTP请求类型
            },
            success(data: any, parameters: any) {
                if (opt.success != undefined && typeof opt.success == 'function') {
                    opt.success(data, parameters);
                }
            },
            error(error: any, message: string, parameters: any) {
                if (opt.error != undefined && typeof opt.error == 'function') {
                    opt.error(error, message, parameters);
                }
            }
        });
    },
    getStudentUsage(opt: any) {
        var servicesPath = baseURL + `/ecode/statistics/period-usage/class/${opt.classId}/bystudent`;
        let context = opt.context;
        let pageData = opt.data || {};
        context.$basicRequest.request({
            url: servicesPath,
            context: context,
            waitingtip: '请稍等...',
            data: pageData,
            ajaxOpt: {
                //ajax的参数配置
                type: 'GET' //HTTP请求类型
            },
            success(data: any, parameters: any) {
                if (opt.success != undefined && typeof opt.success == 'function') {
                    opt.success(data, parameters);
                }
            },
            error(error: any, message: string, parameters: any) {
                if (opt.error != undefined && typeof opt.error == 'function') {
                    opt.error(error, message, parameters);
                }
            }
        });
    },
    getStudentRankList(opt: any) {
        var servicesPath = baseURL + `/ecode/statistics/usage/student-rank-list/school/${opt.schoolId}`;
        let context = opt.context;
        let pageData = opt.data || {};
        context.$basicRequest.request({
            url: servicesPath,
            context: context,
            waitingtip: '请稍等...',
            data: pageData,
            ajaxOpt: {
                //ajax的参数配置
                type: 'GET' //HTTP请求类型
            },
            success(data: any, parameters: any) {
                if (opt.success != undefined && typeof opt.success == 'function') {
                    opt.success(data, parameters);
                }
            },
            error(error: any, message: string, parameters: any) {
                if (opt.error != undefined && typeof opt.error == 'function') {
                    opt.error(error, message, parameters);
                }
            }
        });
    }
};
